import { selectChatImportantUnreadNotifications, selectChatNotifications, selectChatUnreadNotifications } from 'containers/Chats/chatSlice'
import UnverifiedPhonePopup from 'containers/Chats/Notifications/UnverifiedPhonePopup'
import useNotificationAction from 'containers/Chats/hooks/useNotificationAction'
import SendPhotoPopup from 'containers/Chats/Notifications/SendPhotoPopup'
import BasicPopup from 'containers/Chats/Notifications/BasicPopup'
import { selectUser } from 'containers/Login/loginSlice'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import Option from 'components/Option'
import React from 'react'

interface NotificationSummaryProps {
  secondaryTheme?: boolean
}

const NotificationSummary: React.FC<NotificationSummaryProps> = ({ secondaryTheme }) => {
  const { popup, openPopup } = usePopupState<chat.NotificationPopup | undefined>()
  const unreadImportantNotifications = useReduxSelector(selectChatImportantUnreadNotifications)
  const unreadNotifications = useReduxSelector(selectChatUnreadNotifications)
  const notifications = useReduxSelector(selectChatNotifications)
  const user = useReduxSelector(selectUser)

  const { performAction } = useNotificationAction()
  const { t } = useTranslation('chat')
  const { push } = useHistory()

  const userHasUnpaidInvoices = Array.isArray(user?.unpaid_invoices) && user.unpaid_invoices.length > 0
  const userHasUnverifiedPhone = !!user?.hasRequiredInfo?.result && !!user.hasRequiredInfo.fields?.phone && !user.phone_verified_at && user.rentedWarehousesCount === 0
  const allUnreadImportantNotifications = unreadImportantNotifications + (userHasUnpaidInvoices ? 1 : 0)
  const firstImportantNotification = unreadImportantNotifications === 1
    ? notifications.find(notification => notification.isImportant)
    : undefined

  return (
    <div className='account__status'>
      {popup?.type === 'notificationModal' && <BasicPopup
        {...popup.props}
      />}
      {popup?.type === 'sendPhoto' && <SendPhotoPopup
        {...popup.props}
      />}
      {popup?.type === 'unverifiedPhone' && <UnverifiedPhonePopup />}
      {((firstImportantNotification && !userHasUnpaidInvoices) || (!firstImportantNotification && userHasUnpaidInvoices))
        ? firstImportantNotification
          ? <Option
            selected
            dashedBorder
            icon='warning'
            actionOnClick
            buttonText={t('goTo')}
            secondaryTheme={secondaryTheme}
            title={firstImportantNotification.title}
            desc={firstImportantNotification.description}
            action={() => {
              const { id, action, read_date } = firstImportantNotification
              performAction(id, action, read_date)
            }}
          />
          : <Option
            selected
            dashedBorder
            icon='warning'
            actionOnClick
            secondaryTheme={secondaryTheme}
            title={t(user?.unpaid_invoices?.length === 1 ? 'youHaveInvoiceToPay' : 'youHaveInvoicesToPay')}
            desc={`${t('pleasePayInvoices')} ${user?.unpaid_invoices?.length === 1 ? t('invoice') : `${user?.unpaid_invoices?.length} ${t('invoices')}`}`}
            action={() => {
              push('/account/invoices?selectAll=1')
            }}
          />
        : allUnreadImportantNotifications > 0
          ? <Option
            selected
            dashedBorder
            actionOnClick
            icon='warning'
            buttonText={t('look')}
            secondaryTheme={secondaryTheme}
            title={allUnreadImportantNotifications === 1
              ? t('importantMessageAreWaitingForYou')
              : `${allUnreadImportantNotifications} ${t(allUnreadImportantNotifications > 4 ? 'importantMessagesAreWaitingForYou>=5' : 'importantMessagesAreWaitingForYou<5')}`}
            desc={t('checkNow')}
            action={() => {
              push('/chat')
            }}
          />
          : userHasUnverifiedPhone
            ? <Option
              selected
              dashedBorder
              actionOnClick
              icon='phone'
              buttonText={t('check')}
              secondaryTheme={secondaryTheme}
              title={t('unverifiedPhoneTitle')}
              desc={t('unverifiedPhoneSummary')}
              action={() => {
                openPopup({ type: 'unverifiedPhone' })
              }}
            />
            : unreadNotifications > 0
            ? <Option
              selected
              dashedBorder
              actionOnClick
              icon='mail'
              buttonText={t('look')}
              secondaryTheme={secondaryTheme}
              title={unreadNotifications === 1
                ? t('youHaveAnUnreadMessage')
                : unreadNotifications < 5
                  ? `${t('youHave')} ${unreadNotifications} ${t('unreadMessages<5')}`
                  : `${t('youHave')} ${unreadNotifications} ${t('unreadMessages>=5')}`
              }
              desc={t('goToMessages')}
              action={() => {
                push('/chat')
              }}
            />
            : <Option
              icon='check'
              secondaryTheme={secondaryTheme}
              title={t('everythingsAllRight')}
              desc={t('youAreUpToDate')}
            />}
    </div>
  )
}

export default NotificationSummary